/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignedResourceResponse
 */
export interface AssignedResourceResponse {
    /**
     * 
     * @type {string}
     * @memberof AssignedResourceResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedResourceResponse
     */
    lastName: string;
}

/**
 * Check if a given object implements the AssignedResourceResponse interface.
 */
export function instanceOfAssignedResourceResponse(value: object): value is AssignedResourceResponse {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function AssignedResourceResponseFromJSON(json: any): AssignedResourceResponse {
    return AssignedResourceResponseFromJSONTyped(json, false);
}

export function AssignedResourceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignedResourceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function AssignedResourceResponseToJSON(value?: AssignedResourceResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

